export default {
  customerSupport: {
    id: 'product_jp_item_reassurance_customer_support',
    defaultMessage: 'Reliable domestic customer support',
  },
}
